import { effect, Injectable, signal } from '@angular/core';

export enum Theme {
  DARK = 'dark',
  LIGHT = 'light',
}

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor() {
    this.loadTheme();
  }

  currentTheme = signal<Theme>(Theme.LIGHT);

  updateThemeClass = effect(() => {
    document.documentElement.classList.remove('dark');
    if (this.currentTheme() === Theme.DARK) {
      document.documentElement.classList.add('dark');
    }
  });

  toggleTheme() {
    this.currentTheme.set(this.currentTheme() === Theme.DARK ? Theme.LIGHT : Theme.DARK);
    localStorage.setItem('theme', this.currentTheme());
  }

  loadTheme() {
    const storedTheme = localStorage.getItem('theme');
    if (Object.values(Theme).includes(storedTheme as Theme)) {
      this.currentTheme.set(storedTheme as Theme);
    }
  }
}
